import {
  Container,
  Typography,
  Box,
  Stack,
  Button,
  Menu,
  MenuItem,
  IconButton,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Backdrop,
  Skeleton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Autocomplete,
  TextField,
  Chip,
} from '@mui/material';
import FormProvider, {
  RHFEditor,
  RHFTextField,
} from 'src/components/hook-form';
import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import RHFTinyEditor from 'src/components/hook-form/rhf-tiny-editor';
import { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
import { useParams, usePathname, useRouter } from 'src/routes/hooks';
import InviteCandidatesForm from 'src/components/bulk-email-popup/bulk-email-popup';
import {
  fetchInterviews,
  generateInterviewReport,
  regenerateInterviewUrl,
  sendEmailInterview,
} from 'src/services/interview.service';
import { getOrganizationId } from 'src/services/user.service';
import {
  fetchCandidatesByJobId,
  getCandidatesSummary,
  rejectCandidate,
} from 'src/services/candidate.service';
import InfiniteScroll from 'react-infinite-scroll-component';
import JobCandidateProfile from 'src/sections/candidate-profile';
import { paths } from 'src/routes/paths';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { debounce, isEmpty, set } from 'lodash';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useQuery } from 'src/hooks/use-query';
import successTickAnimation from 'src/assets/animations/json/success-tick.json';
import rejectingCandidatesAnimation from 'src/assets/animations/json/rejection-animation.json';
import shortlistingCandidateAnimation from 'src/assets/animations/json/shortlisting-candidate.json';
import { getJobDetails, getTags } from 'src/services/role.service';
import { useBoolean } from 'src/hooks/use-boolean';
import { LoadingScreen } from 'src/components/loading-screen';
import EmptyState from 'src/sections/empty-state';
import Scrollbar from 'src/components/scrollbar';
import Loader from 'src/components/loader';
import { useLocation } from 'react-router-dom';
import JobCandidateRow from '../components/job-candidate-row';
import FiltersDialog from '../components/filters/filters';
import JobCandidateToolbar from '../components/job-candidate-toolbar';
import JobCandidateFilterResult from '../components/job-candidate-filter-result';
import JobCandidateNavbar from '../components/job-candidate-navbar';
import EmailPreview from '../components/email-preview';
import CandidateRowSkeleton from '../components/skeleton/candidate-row';
import { fontWeight } from '@mui/system';
// animations

const JOB_DETAILS_TABS = {
  AI_INTERVIEW: {
    label: 'AI Interview',
    value: 'AI_INTERVIEW',
    tooltip: 'Qualified candidates at AI interview stage',
  },
  IN_PERSON_INTERVIEW: {
    label: 'Interview',
    value: 'IN_PERSON_INTERVIEW',
    tooltip: 'Shortlisted candidate at interview stage',
  },
  NEED_REVIEW: {
    label: 'Needs Review',
    value: 'NEED_REVIEW',
    tooltip: 'Disqualified & Uncategorized candidates',
  },
APPLIED: { label: 'Applied', value: 'APPLIED', tooltip: 'All candidates' },
HIRED: { label: 'Hired', value: 'HIRED', tooltip: 'Hired candidates' },
  REJECTED: {
    label: 'Rejected',
    value: 'REJECTED',
    tooltip: 'Rejected candidates',
  },
  
};

const SCREENING_STATUS_MAP = {
  ANALYZING: {
    label: 'Analyzing',
    value: 'ANALYZING',
    color: 'info',
  },
  AI_INTERVIEW_CREATED: {
    label: 'AI Interview Created',
    value: 'AI_INTERVIEW_CREATED',
    color: 'info',
  },
  AI_INTERVIEW_LINK_SENT: {
    label: 'AI Interview link sent',
    value: 'AI_INTERVIEW_LINK_SENT',
    color: 'info',
  },
  SCREENING_ERROR: {
    label: 'Uncategorized',
    value: 'SCREENING_ERROR',
    color: 'error',
  },
  SCREENING_COMPLETED: {
    label: 'Screening Completed',
    value: 'SCREENING_COMPLETED',
    color: 'success',
  },
  SCREENING_QUALIFIED: {
    label: 'Qualified',
    value: 'SCREENING_QUALIFIED',
    color: 'success',
  },
  SCREENING_DISQUALIFIED: {
    label: 'Disqualified',
    value: 'SCREENING_DISQUALIFIED',
    color: 'error',
  },
  AI_INTERVIEW_IN_PROGRESS: {
    label: 'AI Interview in progress',
    value: 'AI_INTERVIEW_IN_PROGRESS',
    color: 'info',
  },
  AI_INTERVIEW_EVALUATED: {
    label: 'AI Interview Completed',
    value: 'AI_INTERVIEW_EVALUATED',
    color: 'success',
  },
  CODING_INTERVIEW_SUBMITTED:{
    label: 'Coding Interview Submitted',
    value: 'CODING_INTERVIEW_SUBMITTED',
    color: 'success',
  },
  IN_PERSON_INTERVIEW_SCHEDULED: {
    label: 'Interview Scheduled',
    value: 'IN_PERSON_INTERVIEW_SCHEDULED',
    color: 'info',
  },
  CANDIDATE_REJECTED: {
    label: 'Rejected',
    value: 'CANDIDATE_REJECTED',
    color: 'error',
  },
  CANDIDATE_HIRED: {
    label: 'Hired',
    value: 'CANDIDATE_HIRED',
    color: 'success',
  },
};

const SORT_MAP = {
  NONE: {
    label: 'None',
    value: 'AI_INTERVIEW_RANK-ASC',
    arrow: '',
  },
  LATEST: {
    label: 'Latest',
    value: 'CANDIDATE_CREATE_DATE-DESC',
    arrow: 'down',
  },
  OLDEST: {
    label: 'Oldest',
    value: 'CANDIDATE_CREATE_DATE-ASC',
    arrow: 'up',
  },
  A_TO_Z: {
    label: 'A to Z',
    value: 'NAME-ASC',
    arrow: 'down',
  },
  Z_TO_A: {
    label: 'Z to A',
    value: 'NAME-DESC',
    arrow: 'up',
  },
};

const CANDIDATE_ACTIONS_MAP = {
  SHORTLIST_CANDIDATE: {
    value: 'SHORTLIST_CANDIDATE',
    emailTemplate: 'SHORTLISTED',
    type: 'success',
    message:
      '{no-of-candidates} will be shortlisted, and shortlisted email will be sent',
    title: 'Shortlisted email',
    loading: {
      title: 'Shortlisting candidates',
      animation: shortlistingCandidateAnimation,
      message:
        'Shortlisting candidates takes sometime. Hang on for a min or two !!',
    },
    success: {
      title: 'Shortlisted candidates successfully',
      animation: successTickAnimation,
      message: 'You can find these candidates in AI Interview tab',
    },
  },
  REJECT_CANDIDATE: {
    value: 'REJECT_CANDIDATE',
    emailTemplate: 'REJECTED',
    type: 'error',
    message:
      '{no-of-candidates} will be rejected and rejection email will be sent',
    title: 'Rejection email',
    loading: {
      title: 'Rejecting candidates',
      animation: rejectingCandidatesAnimation,
      message:
        'Rejecting candidates takes sometime. Hang on for a min or two !!',
    },
    success: {
      title: 'Rejected candidates successfully',
      animation: successTickAnimation,
      message: 'You can find these candidates in the Rejected tab',
    },
  },
  REMINDER_EMAIL: {
    value: 'REMINDER_EMAIL',
    emailTemplate: 'REMINDER',
    type: 'info',
    message: '{no-of-candidates} will be sent a reminder email',
    title: 'Reminder email',
    loading: {
      title: 'Sending reminder email',
      animation: shortlistingCandidateAnimation,
      message:
        'Sending reminder email takes sometime. Hang on for a min or two !!',
    },
    success: {
      title: 'Reminder email sent successfully',
      animation: successTickAnimation,
      message: 'You can find these candidates in {tab-name} tab',
    },
  },
  CUSTOM_EMAIL: {
    value: 'CUSTOM_EMAIL',
    emailTemplate: 'CUSTOM',
    type: 'info',
    message: '{no-of-candidates} will be sent an email.',
    title: 'Message to the Candidates',
    loading: {
      title: 'Sending email',
      animation: shortlistingCandidateAnimation,
      message: 'Sending email takes sometime. Hang on for a min or two !!',
    },
    success: {
      title: 'Email sent successfully',
      animation: successTickAnimation,
      message: '',
    },
  },
};

export default function JobDetailsView({ jobId, setTitleRole }) {
  const settings = useSettingsContext();
  const { user } = useAuthContext();
  const organization_id = getOrganizationId(user);
  const params = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const router = useRouter();
  const candidatePopover = usePopover();
  const queryParams = useQuery();
  const location = useLocation();
  const pathname = usePathname();

  const queryTab = queryParams.get('tab');
  const queryShowCandidateProfile = queryParams.get('show-candidate-profile');

  // states
  const [filteredCandidateList, setFilteredCandidateList] = useState([]);
  const [currentTab, setCurrentTab] = useState(JOB_DETAILS_TABS.AI_INTERVIEW.value);
  const currentTabRef = useRef(currentTab);
  currentTabRef.current = currentTab;
  const [candidatesCount, setCandidatesCount] = useState({
    APPLIED: location?.state?.candidatesCount?.APPLIED || 0,
    AI_INTERVIEW: location?.state?.candidatesCount?.AI_INTERVIEW || 0,
    IN_PERSON_INTERVIEW:
      location?.state?.candidatesCount?.IN_PERSON_INTERVIEW || 0,
    HIRED: location?.state?.candidatesCount?.HIRED || 0,
    NEED_REVIEW: location?.state?.candidatesCount?.NEED_REVIEW || 0,
    REJECTED: location?.state?.candidatesCount?.REJECTED || 0,
  });
  const [flagFilter, setFlagFilter] = useState(null);
  const [flagCounts, setFlagCounts] = useState({
    SHORTLISTED: 0,
    HOLD: 0,
    FOLLOW_UP: 0,
    REJECT: 0,
  });
  const [totalFlaggedCount, setTotalFlaggedCount] = useState(0);
  const [role, setRole] = useState(null);
  const [jobName, setJobName] = useState(location?.state?.jobName || '');
  const [jobStatus, setJobStatus] = useState(location?.state?.jobStatus || '');
  const [publicApplyLink, setPublicApplyLink] = useState(
    location?.state?.publicApplyLink || '',
  );
  const [isCandidatesLoading, setIsCandidatesLoading] = useState(true);
  const [isCandidatesCountLoading, setIsCandidatesCountLoading] =
    useState(true);
  const [candidatesCurrentPage, setCandidatesCurrentPage] = useState(1);
  const [candidates, setCandidates] = useState([]);
  const [candidateSearchText, setCandidateSearchText] = useState('');
  const [searchResultsCount, setSearchResultsCount] = useState(0);
  const [selectedCandidatePopover, setSelectedCandidatePopover] =
    useState(null);
  const [showCandidateProfile, setShowCandidateProfile] = useState(false);
  const [selectedCandidateId, setSelectedCandidateId] = useState('');
  const [checkedCandidates, setCheckedCandidates] = useState([]);
  const [checkAllCandidates, setCheckAllCandidates] = useState(false);
  const [previousCandidateId, setPreviousCandidateId] = useState('');
  const [nextCandidateId, setNextCandidateId] = useState('');
  const [addCandidateButtonAnchorEl, setAddCandidateButtonAnchorEl] =
    useState(null);
  const isOpenAddCandidateMenu = Boolean(addCandidateButtonAnchorEl);
  const [cameFromLink, setCameFromLink] = useState(false);
  const [showFiltersDialog, setShowFiltersDialog] = useState(false);
  const [filters, setFilters] = useState(null);
  const [sortBy, setSortBy] = useState('NONE');
  const [showFilterResults, setShowFilterResults] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [showSelectionToolbar, setShowSelectionToolbar] = useState(false);
  const [openEmailPreview, setOpenEmailPreview] = useState(false);
  const [emailPreviewType, setEmailPreviewType] = useState('');
  const [isCandidateProfileLoading, setIsCandidateProfileLoading] =
    useState(false);
  const [showBackdropLoader, setShowBackdropLoader] = useState(false);
  const [showCandidateRowSkeleton, setShowCandidateRowSkeleton] =
    useState(true);
  const [isJobLoading, setIsJobLoading] = useState(false);
  const [isEmptyState, setIsEmptyState] = useState(false);
  const [isFetchingTags, setIsFetchingTags] = useState(false);
  const [allTags, setAllTags] = useState([]);

  // const [inviteCandidatePopup,setInviteCandidatePopup] = useState(false);
  // const showConfirmationMessage = useBoolean(false);
  const isEditModalOpen = useBoolean(false);
  // const isSubmitting = useBoolean(false);
  // const [tagInputValue, setTagInputValue] = useState('');

  // functions
  const getJob = useCallback(() => {
    setIsJobLoading(true);
    getJobDetails(organization_id, jobId)
      .then(data => {
        if (data.success) {
          setRole(data.body);
          setJobName(data.body.name);
          setJobStatus(data.body.status);
          setTitleRole(data.body.name);
          setPublicApplyLink(data.body.public_apply_link);
        } else throw new Error(data.message);
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setIsJobLoading(false);
      });
  }, [jobId, organization_id, setTitleRole]);

  const getCandidatesList = useCallback(
    (page, rowsPerPage, candidateSearch, showLoader = true) => {
      if (currentTab) {
        if (showLoader) setIsCandidatesLoading(true);

        let payload = {};

        const filter_map = {};

        const [_sortBy, _sortOrder] = SORT_MAP[sortBy].value.split('-');

        if (candidateSearch) filter_map.NAME = candidateSearch;
        if (flagFilter) filter_map.FLAG = flagFilter;

        payload = {
          filter_map,
          sort_by: _sortBy,
          sort_order: _sortOrder,
          candidate_group: currentTab,
        };

        fetchCandidatesByJobId(
          organization_id,
          jobId,
          rowsPerPage,
          page,
          payload,
        )
          .then(data => {
            if (data !== undefined && data !== null && data.success) {
              const _candidates = data.body.candidates.map(candidate => {
                const _data = {
                  id: candidate.candidate_info.user_id,
                  interviewId: candidate.interview_details?.interview_id,
                  rank: candidate.interview_details
                    ? candidate.interview_details.rank
                    : null,
                  name: candidate.candidate_info.name,
                  email: candidate.candidate_info.email,
                  mobNo: candidate.candidate_info.phone_number,
                  currentRole: candidate.candidate_info?.current_role || '',
                  currentOrg: candidate.candidate_info?.current_org || '',
                  stage: candidate.job_candidate_stage,
                  aiRecommendation: candidate.ai_recommendation,
                  screeningStatus: candidate.screening_status,
                  tags: candidate.candidate_info.tags,
                  source: candidate.candidate_info.candidate_source,
                  preScreeningQualified: candidate.pre_screening_qualified,
                  screeningQualified: candidate.screening_qualified,
                  score: candidate.interview_details
                    ? candidate.interview_details.total_score
                    : null,
                  isEmailSent: candidate.interview_details
                    ? candidate.interview_details.email_sent
                    : null,
                  createdAt: candidate.created_at,
                  updatedAt: candidate.updated_at,
                  current_stage_flag: candidate.current_stage_flag,
                };
                return _data;
              });

              // http://localhost:3030/dashboard/job/6534a7230ac1e155f623e600

              if (checkAllCandidates) {
                setCheckedCandidates(prevProps => {
                  const _checkedCandidates = [
                    ...prevProps,
                    ..._candidates.map(item => ({
                      id: item.id,
                      screeningStatus: item.screeningStatus,
                    })),
                  ];
                  return _checkedCandidates;
                });
              }

              setCandidates(prevCandidates => [
                ...prevCandidates,
                ..._candidates,
              ]);

              if (candidateSearch) {
                setSearchResultsCount(data.body.total_candidates);
              }
            } else throw new Error('Something went wrong');
          })
          .catch(err => console.log(err))
          .finally(() => {
            setIsCandidatesLoading(false);
            setShowCandidateRowSkeleton(false);
          });
      }
    },
    [currentTab, sortBy, flagFilter, organization_id, jobId, checkAllCandidates],
  );

  const getCandidatesCount = useCallback(
    showCandidatesCountLoader => {
      if (showCandidatesCountLoader) setIsCandidatesCountLoading(true);
      getCandidatesSummary(organization_id, jobId, currentTabRef.current)
        .then(data => {
          if (data.success) {
            setCandidatesCount({
              APPLIED: data.body.candidate_group_map.APPLIED,
              AI_INTERVIEW: data.body.candidate_group_map.AI_INTERVIEW,
              IN_PERSON_INTERVIEW:
                data.body.candidate_group_map.IN_PERSON_INTERVIEW,
              HIRED: data.body.candidate_group_map.HIRED,
              NEED_REVIEW: data.body.candidate_group_map.NEED_REVIEW,
              REJECTED: data.body.candidate_group_map.REJECTED,
            });
            setFlagCounts({
              SHORTLISTED: data.body.flag_count_map?.SHORTLISTED || 0,
              HOLD: data.body.flag_count_map?.HOLD || 0,
              FOLLOW_UP: data.body.flag_count_map?.FOLLOW_UP || 0,
              REJECT: data.body.flag_count_map?.REJECT || 0,
            });
            setTotalFlaggedCount(data.body.total_flagged_count || 0);
            setFilters(data?.body?.job_filter);
          }
        })
        .catch(err => console.log(err))
        .finally(() => {
          setIsCandidatesCountLoading(false);
        });
    },
    [jobId, organization_id],
  );

  const fetchMoreCandidates = useCallback(() => {
    const nextPage = candidatesCurrentPage + 1;
    setCandidatesCurrentPage(nextPage);
    getCandidatesList(nextPage, 10);
  }, [candidatesCurrentPage, getCandidatesList]);

  const copyJobApplyLink = async () => {
    const jobApplyLink = `${process.env.REACT_APP_APPLY_JOB_BASE_URL}${publicApplyLink}`;
    await navigator.clipboard.writeText(jobApplyLink);
    enqueueSnackbar('Copied');
  };

  const sendEmail = async id => {
    const reqBody = {
      interview_ids: [id],
    };

    const response = await sendEmailInterview(jobId, reqBody);

    try {
      if (response.success) {
        enqueueSnackbar('Email request submitted!');
      } else throw new Error('Something went wrong');
    } catch (err) {
      enqueueSnackbar({
        message: 'Something went wrong!',
        variant: 'error',
      });
    }
  };

  const downloadReport = async () => {
    const reqBody = {
      report_type: 'JOB_CANDIDATE_REPORT',
      job_opening_id: jobId,
    };

    generateInterviewReport(organization_id, reqBody)
      .then(res => {
        if (res.success) {
          enqueueSnackbar(
            'Request sent successfully, Check in Reports tab after sometime',
          );
        } else throw new Error('Something went wrong');
      })
      .catch(err => {
        enqueueSnackbar({
          message: 'Something went wrong',
          variant: 'error',
        });
      });
  };

  const handleSearchCandidate = debounce(e => {
    const { value } = e.target;
    setCandidateSearchText(value);

    if (!showFilterResults) {
      setCandidatesCurrentPage(1);
      setCandidates([]);
      getCandidatesList(1, 10, value);
    }
  }, 500);

  const updateCandidateFlag = (item, flag) => {
    console.log('update transferred');
    setCandidates(candidates => {
      return candidates.map(candidate => {
        if (candidate.id === item.id) {
          console.log('Matched id');
          console.log(candidate);
          const cv = {
            ...candidate,
            current_stage_flag: flag,
          };

          console.log(cv);
          return cv;
        }
        return candidate;
      });
    });

    const previousFlagName = item.current_stage_flag?.candidate_stage_flag_name;
    const newFlagName = flag?.candidate_stage_flag_name;
    if (previousFlagName !== newFlagName) {
      setFlagCounts(prevCounts => {
        const updatedCounts = { ...prevCounts };
        if (previousFlagName) updatedCounts[previousFlagName] -= 1;
        if (newFlagName) updatedCounts[newFlagName] = (updatedCounts[newFlagName] || 0) + 1;
        return updatedCounts;
      });
      setTotalFlaggedCount(
        prevTotal => prevTotal + (newFlagName ? 1 : 0) - (previousFlagName ? 1 : 0),
      );
    }
  };

  const getFilteredCandidates = useCallback(
    list => {
      const value = candidateSearchText.toLowerCase().trim();
      const _candidates = list.filter(candidate =>
        candidate.name.toLowerCase().includes(value),
      );

      return _candidates;
    },
    [candidateSearchText],
  );

  const refetchCandidates = (
    showCandidatesCountLoader,
    showCandidatesListLoader,
  ) => {
    setCandidatesCurrentPage(1);
    setCandidates([]);
    getCandidatesCount(showCandidatesCountLoader);
    getCandidatesList(1, 10, '', showCandidatesListLoader);
  };

  const onPreviousHandler = useCallback(() => {
    setIsCandidateProfileLoading(true);

    let _candidates = [];

    if (showFilterResults) {
      _candidates = getFilteredCandidates(filteredCandidateList);
    } else {
      _candidates = candidates;
    }

    const currentIndex = _candidates.findIndex(
      candidate => candidate.id === selectedCandidateId,
    );

    const _previousCandidateId = _candidates[currentIndex - 1]?.id || '';

    if (_previousCandidateId) {
      setSelectedCandidateId(_previousCandidateId);
    }

    const currPreviousCandidateId = _candidates[currentIndex - 2]?.id || '';
    const currNextCandidateId = _candidates[currentIndex]?.id || '';

    setPreviousCandidateId(currPreviousCandidateId);
    setNextCandidateId(currNextCandidateId);
  }, [
    candidates,
    filteredCandidateList,
    getFilteredCandidates,
    selectedCandidateId,
    showFilterResults,
  ]);

  const onNextHandler = useCallback(() => {
    setIsCandidateProfileLoading(true);

    let _candidates = [];

    if (showFilterResults) {
      _candidates = getFilteredCandidates(filteredCandidateList);
    } else {
      _candidates = candidates;
    }

    const currentIndex = _candidates.findIndex(
      candidate => candidate.id === selectedCandidateId,
    );

    if (
      _candidates.length < candidatesCount[currentTab] &&
      _candidates.length - currentIndex < 5
    ) {
      fetchMoreCandidates();
    }

    const _nextCandidateId = _candidates[currentIndex + 1]?.id || '';

    if (_nextCandidateId) {
      setSelectedCandidateId(_nextCandidateId);
    }

    const currPreviousCandidateId = _candidates[currentIndex]?.id || '';
    const currNextCandidateId = _candidates[currentIndex + 2]?.id || '';

    setPreviousCandidateId(currPreviousCandidateId);
    setNextCandidateId(currNextCandidateId);
  }, [
    candidates,
    candidatesCount,
    currentTab,
    fetchMoreCandidates,
    filteredCandidateList,
    getFilteredCandidates,
    selectedCandidateId,
    showFilterResults,
  ]);

  const getCurrentCandidateIndex = () => {
    let _candidates = [];

    if (showFilterResults) {
      _candidates = getFilteredCandidates(filteredCandidateList);
    } else {
      _candidates = candidates;
    }

    return (
      _candidates.findIndex(candidate => candidate.id === selectedCandidateId) +
      1
    );
  };

  const onViewProfile = candidateId => {
    setShowBackdropLoader(true);
    setIsCandidateProfileLoading(true);

    let _candidates = [];

    if (showFilterResults) {
      _candidates = getFilteredCandidates(filteredCandidateList);
    } else {
      _candidates = candidates;
    }

    const index = _candidates.findIndex(
      _candidate => _candidate.id === candidateId,
    );

    setPreviousCandidateId(_candidates[index - 1]?.id || '');
    setNextCandidateId(_candidates[index + 1]?.id || '');
    setSelectedCandidateId(candidateId);
  };

  const getTotalCandidatesCount = () => {
    if (showFilterResults) {
      return getFilteredCandidates(filteredCandidateList).length;
    }
    return candidatesCount[currentTab];
  };

  const getCheckedScreeningStatuses = () => {
    const statuses = checkedCandidates.map(item =>
      SCREENING_STATUS_MAP[item.screeningStatus].label.toLowerCase(),
    );
    const uniqueStatuses = [...new Set(statuses)];
    return uniqueStatuses.join('& ');
  };

  const resetCheckedCandidates = () => {
    if (checkedCandidates.length > 0) {
      setCheckAllCandidates(false);
      setCheckedCandidates([]);
      setShowSelectionToolbar(false);
      setShowNavbar(true);
    }
  };

  const handleCandidatePopoverClose = () => {
    candidatePopover.onClose();
    setSelectedCandidatePopover(null);
  };

  const inviteCandidateViaMail = () => {
    isEditModalOpen.onTrue();
  };

  const handleModalClose = () => {
    isEditModalOpen.onFalse();
    // console.log(isEditModalOpen);
  };

  const fetchTags = useCallback(
    async (showLoader = true) => {
      try {
        if (showLoader) {
          setIsFetchingTags(true);
        }

        const response = await getTags(organization_id);
        if (response.success) {
          setAllTags(response.body);

          return response.body;
        }
          throw new Error(response.message);

      } catch (err) {
        console.log('err', err);
      } finally {
        setIsFetchingTags(false);
      }
    },
    [organization_id],
  );

  // effects
  useEffect(() => {
    getJob();
    getCandidatesCount();
  }, [getCandidatesCount, getJob]);

  useEffect(() => {
    setCheckedCandidates([]);
    refetchCandidates(false);
  }, [currentTab, sortBy, flagFilter]);

  useEffect(() => {
    if (showFilterResults) setFlagFilter(null);
  }, [showFilterResults]);

  // useEffect(() => {
  //   if (queryTab) setCurrentTab(queryTab);
  //   else
  //     router.replace(
  //       `${paths.dashboard.jobs.candidates.details(jobId)}?tab=APPLIED`,
  //     );
  // }, [queryTab]);

  useEffect(() => {
    if (queryShowCandidateProfile) {
      setSelectedCandidateId(queryShowCandidateProfile);
      setCameFromLink(true);
    } else {
      setCameFromLink(false);
    }
  }, []);

  useEffect(() => {
    if (isCandidatesLoading) {
      setIsEmptyState(false);
    } else if (!isCandidatesLoading) {
      if (showFilterResults) {
        const hasFilteredCandidates = getFilteredCandidates(
          filteredCandidateList,
        ).length;

        if (hasFilteredCandidates) {
          setIsEmptyState(false);
        } else {
          setIsEmptyState(true);
        }
      } else if (candidates.length) {
        setIsEmptyState(false);
      } else {
        setIsEmptyState(true);
      }
    }
  }, [
    candidates.length,
    filteredCandidateList,
    getFilteredCandidates,
    isCandidatesLoading,
    showFilterResults,
  ]);

  useEffect(() => {
    const handleBackgroundScroll = () => {
      if (showBackdropLoader) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    if (typeof window !== 'undefined' && window.document) {
      handleBackgroundScroll();
    }
  }, [showBackdropLoader]);

  useEffect(() => {
    if (showCandidateProfile) {
      setShowBackdropLoader(true);
    } else {
      setShowBackdropLoader(false);
    }
  }, [showCandidateProfile]);

  useEffect(() => {
    const handleBackgroundScroll = () => {
      if (showBackdropLoader) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    if (typeof window !== 'undefined' && window.document) {
      handleBackgroundScroll();
    }
  }, [showBackdropLoader]);

  useEffect(() => {
    if (showCandidateProfile) {
      setShowBackdropLoader(true);
    } else {
      setShowBackdropLoader(false);
    }
  }, [showCandidateProfile]);

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  return (
    <>
      <InviteCandidatesForm
        isOpen={isEditModalOpen.value}
        onClose={handleModalClose}
        orgId={organization_id}
        jobId={jobId}
      />
      <Container
        sx={{
          pt: '42.5px',
          pb: '24px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          '@media (min-width: 600px)': {
            px: '0px',
          },
        }}
        maxWidth={settings.themeStretch ? false : 'lg'}
      >
        {showFiltersDialog && filters && (
          <FiltersDialog
            open={showFiltersDialog}
            setOpen={setShowFiltersDialog}
            filters={filters}
            setShowFilterResults={setShowFilterResults}
            organization_id={organization_id}
            setFilteredCandidateList={setFilteredCandidateList}
            jobId={jobId}
            setShowNavbar={setShowNavbar}
          />
        )}

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb="40px"
          px="50px"
        >
          <Stack direction="row" alignItems="center" spacing="8px">
            {jobName ? (
              <Typography variant="h2" fontWeight={600}>
                {jobName}
              </Typography>
            ) : (
              <Skeleton width={220} height={26} />
            )}
            {publicApplyLink ? (
              <IconButton onClick={copyJobApplyLink}>
                <Iconify icon="tabler:link" />
              </IconButton>
            ) : (
              <Skeleton width={32} height={32} variant="circular" />
            )}
            <IconButton
              onClick={() => router.push(paths.dashboard.jobs.edit(jobId))}
            >
              <Iconify icon="tabler:pencil" />
            </IconButton>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton variant="outlined" onClick={downloadReport}>
              <Iconify icon="tabler:download" />
            </IconButton>
            <IconButton variant="outlined" onClick={inviteCandidateViaMail}>
              <Iconify icon="tabler:mail-share" />
            </IconButton>
            {jobStatus ? (
              <Tooltip
                title={jobStatus === 'ARCHIVED' ? 'Job is archived' : ''}
              >
                <Box>
                  <Button
                    variant="contained"
                    id="add-candidate-button"
                    disabled={jobStatus === 'ARCHIVED'}
                    aria-controls={
                      isOpenAddCandidateMenu ? 'add-candidate-menu' : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={isOpenAddCandidateMenu ? 'true' : undefined}
                    startIcon={
                      <Iconify color="currentColor" icon="tabler:plus" />
                    }
                    endIcon={
                      <Iconify
                        color="currentColor"
                        icon="tabler:chevron-down"
                      />
                    }
                    onClick={event =>
                      setAddCandidateButtonAnchorEl(event.currentTarget)
                    }
                  >
                    Add Candidate
                  </Button>

                  <Menu
                    id="add-candidate-menu"
                    anchorEl={addCandidateButtonAnchorEl}
                    open={isOpenAddCandidateMenu}
                    onClose={() => setAddCandidateButtonAnchorEl(null)}
                    MenuListProps={{
                      'aria-labelledby': 'add-candidate-button',
                    }}
                    sx={{
                      '& .MuiMenu-paper': {
                        width: '167px',
                        maxWidth: '100%',
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() =>
                        router.push(
                          `${paths.dashboard.jobs.candidates.add(
                            jobId,
                          )}?type=resume`,
                        )
                      }
                    >
                      Upload Resume
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        router.push(
                          `${paths.dashboard.jobs.candidates.add(
                            jobId,
                          )}?type=excel`,
                        )
                      }
                    >
                      Upload Excel
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        router.push(
                          `${paths.dashboard.jobs.candidates.add(
                            jobId,
                          )}?type=manual`,
                        )
                      }
                    >
                      Add Manually
                    </MenuItem>
                  </Menu>
                </Box>
              </Tooltip>
            ) : (
              <Skeleton width={148} height={45} />
            )}
          </Stack>
        </Stack>
        <JobCandidateToolbar
          filters={filters}
          handleSearchCandidate={handleSearchCandidate}
          setShowFiltersDialog={setShowFiltersDialog}
          SORT_MAP={SORT_MAP}
          sortBy={sortBy}
          setSortBy={setSortBy}
          isCandidatesLoading={isCandidatesLoading}
          isShowingFilterResult={!!filteredCandidateList.length}
          resetCheckedCandidates={resetCheckedCandidates}
          flagFilter={flagFilter}
          setFlagFilter={setFlagFilter}
          flagCounts={flagCounts}
          totalFlaggedCount={totalFlaggedCount}
          isRegularFilterActive={showFilterResults}
        />

        <Box position="relative">
          {showSelectionToolbar && (
            <FormControlLabel
              sx={{
                position: 'absolute',
                left: '24px',
                top: '30%',
              }}
              control={
                <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root': {
                      width: '20px',
                      height: '20px',
                    },
                  }}
                  indeterminate
                  onChange={e => resetCheckedCandidates()}
                />
              }
            />
          )}
          <Stack mb="20px" height="73.33px" px="50px" justifyContent="center">
            {showNavbar ? (
              <JobCandidateNavbar
                JOB_DETAILS_TABS={JOB_DETAILS_TABS}
                candidatesCount={candidatesCount}
                setCurrentTab={setCurrentTab}
                currentTab={currentTab}
                jobId={jobId}
                isActive={currentTab}
                isCandidatesCountLoading={isCandidatesCountLoading}
              />
            ) : null}
            {showFilterResults ? (
              <JobCandidateFilterResult
                filteredCandidateList={filteredCandidateList}
                setFilteredCandidateList={setFilteredCandidateList}
                filterResultsCount={
                  getFilteredCandidates(filteredCandidateList).length
                }
                setShowFilterResults={setShowFilterResults}
                setShowNavbar={setShowNavbar}
              />
            ) : null}
            {showSelectionToolbar ? (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="row" alignItems="center">
                  <Typography variant="input" fontWeight={500} mr="3px">
                    {`${
                      checkAllCandidates
                        ? `${
                            candidatesCount[currentTab] === 1
                              ? `${candidatesCount[currentTab]} candidate`
                              : `${candidatesCount[currentTab]} candidates`
                          }`
                        : `${
                            checkedCandidates.length === 1
                              ? `${checkedCandidates.length} candidate`
                              : `${checkedCandidates.length} candidates`
                          }`
                    }`}
                  </Typography>
                  <Typography variant="input" fontWeight={500} mr="8px">
                    selected
                  </Typography>
                  <Typography
                    variant="input"
                    fontWeight={600}
                    sx={{
                      cursor: 'pointer',
                    }}
                    color={theme => theme.palette.content.accent1}
                    onClick={() => {
                      if (
                        checkAllCandidates ||
                        checkedCandidates.length === candidates.length
                      ) {
                        resetCheckedCandidates();
                      } else {
                        setCheckAllCandidates(true);
                        setCheckedCandidates(
                          candidates.map(item => ({
                            id: item.id,
                            screeningStatus: item.screeningStatus,
                          })),
                        );
                      }
                    }}
                  >
                    {checkAllCandidates ||
                    checkedCandidates.length === candidates.length ? (
                      <Typography variant="input" fontWeight={600}>
                        Clear selection
                      </Typography>
                    ) : (
                      <Typography variant="input" fontWeight={600}>
                        Select all in {`${JOB_DETAILS_TABS[currentTab].label}`}
                      </Typography>
                    )}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing="20px">
                  {currentTab !== JOB_DETAILS_TABS.REJECTED.value && (
                    <Button
                      variant="contained"
                      startIcon={<Iconify icon="tabler:mail" />}
                      onClick={() => {
                        setEmailPreviewType(
                          CANDIDATE_ACTIONS_MAP.CUSTOM_EMAIL.value,
                        );
                        setOpenEmailPreview(true);
                      }}
                    >
                      Send Email
                    </Button>
                  )}

                  {currentTab === JOB_DETAILS_TABS.NEED_REVIEW.value && (
                    <Button
                      variant="contained"
                      color="error"
                      startIcon={<Iconify icon="tabler:x" />}
                      onClick={() => {
                        setEmailPreviewType(
                          CANDIDATE_ACTIONS_MAP.REJECT_CANDIDATE.value,
                        );
                        setOpenEmailPreview(true);
                      }}
                    >
                      Reject All
                    </Button>
                  )}
                  {currentTab === JOB_DETAILS_TABS.NEED_REVIEW.value && (
                    <Button
                      variant="contained"
                      startIcon={<Iconify icon="tabler:check" />}
                      onClick={() => {
                        setEmailPreviewType(
                          CANDIDATE_ACTIONS_MAP.SHORTLIST_CANDIDATE.value,
                        );
                        setOpenEmailPreview(true);
                      }}
                    >
                      Shortlist All
                    </Button>
                  )}
                </Stack>
              </Stack>
            ) : null}
          </Stack>
        </Box>

        {isCandidatesLoading && showCandidateRowSkeleton && (
          <CandidateRowSkeleton />
        )}

        {!isEmptyState && showFilterResults && (
          <Stack spacing="16px">
            {getFilteredCandidates(filteredCandidateList).map(candidate => (
              <JobCandidateRow
                key={candidate.id}
                jobId={params?.id}
                candidate={candidate}
                screeningStatusMap={SCREENING_STATUS_MAP}
                candidatePopover={candidatePopover}
                setSelectedCandidatePopover={setSelectedCandidatePopover}
                onViewProfile={() => {
                  if (!candidate.screeningStatus) {
                    onViewProfile(candidate.id);
                  } else if (
                    SCREENING_STATUS_MAP[candidate.screeningStatus].value !==
                    SCREENING_STATUS_MAP.ANALYZING.value
                  )
                    onViewProfile(candidate.id);
                }}
                checkedCandidates={checkedCandidates}
                setCheckedCandidates={setCheckedCandidates}
                checkAllCandidates={checkAllCandidates}
                setCheckAllCandidates={setCheckAllCandidates}
                setShowSelectionToolbar={setShowSelectionToolbar}
                setShowNavbar={setShowNavbar}
                showFilterResults={showFilterResults}
                updateCandidateFlag={updateCandidateFlag}
                allTags={allTags}
                fetchTags={() => fetchTags(false)}
                isFetchingTags={isFetchingTags}
              />
            ))}
          </Stack>
        )}

        {!isEmptyState &&
          !showFilterResults &&
          flagFilter &&
          !isCandidatesLoading &&
          candidates.length === 0 && (
            <Stack alignItems="center" justifyContent="center" py="40px">
              <Typography variant="input">
                No flagged candidates found.{' '}
                <Typography
                  component="span"
                  variant="input"
                  fontWeight={600}
                  sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                  color={theme => theme.palette.content.accent1}
                  onClick={() => setFlagFilter(null)}
                >
                  Clear filter
                </Typography>
              </Typography>
            </Stack>
          )}

        {!isEmptyState &&
          !showFilterResults &&
          !(flagFilter && !isCandidatesLoading && candidates.length === 0) && (
          <InfiniteScroll
            dataLength={candidates.length}
            next={fetchMoreCandidates}
            hasMore={(() => {
              if (isCandidatesLoading) return true;

              if (candidateSearchText && searchResultsCount)
                return candidates.length < searchResultsCount;
              return candidates.length < candidatesCount[currentTab];
            })()}
            loader={
              <Stack width="100%" alignItems="center" justifyContent="center">
                Loading...
              </Stack>
            }
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            {candidates.map(candidate => (
              <JobCandidateRow
                key={candidate.id}
                jobId={params?.id}
                candidate={candidate}
                screeningStatusMap={SCREENING_STATUS_MAP}
                candidatePopover={candidatePopover}
                setSelectedCandidatePopover={setSelectedCandidatePopover}
                checkedCandidates={checkedCandidates}
                setCheckedCandidates={setCheckedCandidates}
                onViewProfile={() => {
                  if (!candidate.screeningStatus) {
                    onViewProfile(candidate.id);
                  } else if (
                    SCREENING_STATUS_MAP[candidate.screeningStatus].value !==
                    SCREENING_STATUS_MAP.ANALYZING.value
                  )
                    onViewProfile(candidate.id);
                }}
                JOB_DETAILS_TABS={JOB_DETAILS_TABS}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                checkAllCandidates={checkAllCandidates}
                setCheckAllCandidates={setCheckAllCandidates}
                setShowSelectionToolbar={setShowSelectionToolbar}
                setShowNavbar={setShowNavbar}
                showFilterResults={showFilterResults}
                updateCandidateFlag={updateCandidateFlag}
                allTags={allTags}
                fetchTags={() => fetchTags(false)}
                isFetchingTags={isFetchingTags}
              />
            ))}
          </InfiniteScroll>
        )}

        {isEmptyState && (
          <Stack m="auto">
            <EmptyState />
          </Stack>
        )}

        {openEmailPreview && (
          <EmailPreview
            open={openEmailPreview}
            onClose={() => {
              setEmailPreviewType('');
              setOpenEmailPreview(false);
            }}
            noOfCandidates={
              checkAllCandidates
                ? candidatesCount[currentTab]
                : checkedCandidates.length
            }
            type={emailPreviewType}
            CANDIDATE_ACTIONS_MAP={CANDIDATE_ACTIONS_MAP}
            JOB_DETAILS_TABS={JOB_DETAILS_TABS}
            checkAllCandidates={checkAllCandidates}
            jobId={jobId}
            checkCandidates={checkedCandidates}
            currentTab={currentTab}
            setCheckedCandidates={setCheckedCandidates}
            setCheckAllCandidates={setCheckAllCandidates}
            setShowSelectionToolbar={setShowSelectionToolbar}
            setShowNavbar={setShowNavbar}
            refetchCandidates={refetchCandidates}
          />
        )}

        {selectedCandidatePopover && (
          <CustomPopover
            open={candidatePopover.open}
            onClose={handleCandidatePopoverClose}
            sx={{ width: 200 }}
          >
            <MenuItem
              onClick={() => {
                onViewProfile(selectedCandidatePopover.id);
                handleCandidatePopoverClose();
              }}
            >
              View profile
            </MenuItem>
            <MenuItem
              onClick={() => {
                router.push(
                  `/dashboard/candidates/edit/${
                    selectedCandidatePopover.id
                  }?${new URLSearchParams({
                    returnTo: window.location.pathname,
                  }).toString()}`,
                );
                handleCandidatePopoverClose();
              }}
            >
              Edit Candidate
            </MenuItem>
            {currentTab !== JOB_DETAILS_TABS.REJECTED.value && (
              <MenuItem
                onClick={() => {
                  setEmailPreviewType(CANDIDATE_ACTIONS_MAP.CUSTOM_EMAIL.value);
                  setCheckedCandidates(
                    [{
                      id: selectedCandidatePopover.id,
                      screeningStatus: '',
                    }]),
                  setOpenEmailPreview(true);
                  handleCandidatePopoverClose();
                }}
              >
                Send email
              </MenuItem>
            )}
            {selectedCandidatePopover.screeningStatus ===
              SCREENING_STATUS_MAP.AI_INTERVIEW_CREATED.value && (
              <MenuItem
                onClick={async () => {
                  sendEmail(selectedCandidatePopover.interviewId);
                  handleCandidatePopoverClose();
                }}
              >
                Send interview email
              </MenuItem>
            )}
            {selectedCandidatePopover.screeningStatus ===
              SCREENING_STATUS_MAP.AI_INTERVIEW_LINK_SENT.value && (
              <MenuItem
                onClick={() => {
                  sendEmail(selectedCandidatePopover.interviewId);
                  handleCandidatePopoverClose();
                }}
              >
                Interview reminder email
              </MenuItem>
            )}
            {selectedCandidatePopover.interviewId && (
              <MenuItem
                onClick={() => {
                  regenerateInterviewUrl(
                    jobId,
                    selectedCandidatePopover.interviewId,
                  )
                    .then(res => {
                      if (res.success) {
                        enqueueSnackbar(
                          'Regenerated interview link successfully',
                        );
                      } else throw new Error('Something went wrong');
                    })
                    .catch(err => {
                      console.log(err);
                      enqueueSnackbar({
                        message: 'Something went wrong',
                        variant: 'error',
                      });
                    });
                  handleCandidatePopoverClose();
                }}
              >
                Regenerate link
              </MenuItem>
            )}
            {selectedCandidatePopover.screeningStatus !==
              SCREENING_STATUS_MAP.CANDIDATE_REJECTED.value &&
              selectedCandidatePopover.screeningStatus !==
                SCREENING_STATUS_MAP.CANDIDATE_HIRED.value && (
                <MenuItem
                  onClick={() => {
                    rejectCandidate(
                      organization_id,
                      jobId,
                      selectedCandidatePopover.id,
                    )
                      .then(res => {
                        console.log(res);
                        refetchCandidates(false);
                      })
                      .catch(err => {
                        console.log(err);
                      });

                    handleCandidatePopoverClose();
                  }}
                >
                  Reject Candidate
                </MenuItem>
              )}
          </CustomPopover>
        )}

        <Backdrop
          sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
          open={
            isCandidateProfileLoading &&
            showBackdropLoader &&
            !showCandidateProfile
          }
        >
          <Stack
            height="100vh"
            width="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Loader width={120} height={120} />
          </Stack>
        </Backdrop>

        <JobCandidateProfile
          candidateType="JOB_CANDIDATE"
          role={role?.name}
          open={showCandidateProfile}
          jobId={jobId}
          setOpen={setShowCandidateProfile}
          candidateId={selectedCandidateId}
          currentCandidateIndex={
            cameFromLink ? null : getCurrentCandidateIndex()
          }
          totalCandidates={cameFromLink ? null : getTotalCandidatesCount()}
          onClose={() => {
            setPreviousCandidateId('');
            setNextCandidateId('');
            setSelectedCandidateId('');
            setShowCandidateProfile(false);
            setCameFromLink(false);
          }}
          hasPrevious={!!previousCandidateId}
          hasNext={!!nextCandidateId}
          onPrevious={onPreviousHandler}
          onNext={onNextHandler}
          isLoading={isCandidateProfileLoading}
          setIsLoading={setIsCandidateProfileLoading}
          setShowCandidateProfile={setShowCandidateProfile}
          needCodingAssessment={role?.need_coding_assessment}
          interactiveInterviewEnabled={false && role?.two_way_interview_enabled}
          updateCandidateFlag={updateCandidateFlag}
        />
      </Container>
    </>
  );
}

JobDetailsView.propTypes = {
  jobId: PropTypes.string,
  setTitleRole: PropTypes.func,
};
